import { Modal } from "antd";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { LMMultiSelect } from "../../../components/LMMultiSelect";
import { RootState } from "../../../app/store";
import { LMNewButton } from "../../../components/LMNewButton";
import { assignUserToRole } from "../api";
import styles from "./AssignUserModal.module.css";

interface Props {
  onCancel: () => void;
  onRefresh: () => void;
  roleId: string | null;
  onSuccess: () => void;
  onError: () => void;
}

export const AssignUserModal: FC<Props> = ({
  onCancel,
  roleId,
  onRefresh,
  onSuccess,
  onError,
}) => {
  const { t } = useTranslation("users");
  const [usersIds, setUsersIds] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const users = useSelector((state: RootState) => {
    return state.users.simpleList;
  });

  const handleSelectUsers = (value: string[]) => {
    setUsersIds(value);
  };

  const handleAssign = async () => {
    if (!roleId) return;
    setLoading(true);
    try {
      for (const userId of usersIds) {
        await assignUserToRole(userId, roleId);
      }
      await setTimeout(() => {
        setLoading(false);
        onSuccess();
        onCancel();
        onRefresh();
      }, 3000);
    } catch {
      setLoading(false);
      onError();
    }
  };

  return (
    <>
      <Modal
        open={roleId !== null}
        width={400}
        footer={null}
        className={styles.container}
        title={t("assignUser")}
        onCancel={onCancel}
      >
        <div className={styles.content}>
          <LMMultiSelect
            value={usersIds}
            onChange={handleSelectUsers}
            placeholder={t("assignRolePlaceholder")}
            items={users.map((user) => ({
              name: user.userName,
              value: user.id,
            }))}
          />
          <div className={styles.buttons}>
            <LMNewButton
              color="default"
              onClick={onCancel}
              className={styles.button}
            >
              {t("cancel")}
            </LMNewButton>
            <LMNewButton
              onClick={handleAssign}
              disabled={usersIds.length === 0 || loading}
              className={styles.button}
            >
              {t("add")}
            </LMNewButton>
          </div>
        </div>
      </Modal>
    </>
  );
};
